import { render } from "./KPITable.vue?vue&type=template&id=a1fadc7e&scoped=true"
import script from "./KPITable.vue?vue&type=script&lang=js"
export * from "./KPITable.vue?vue&type=script&lang=js"

import "./KPITable.vue?vue&type=style&index=0&id=a1fadc7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1fadc7e"]])

export default __exports__